import { MAX_ROW_LIMIT, buildResource, fetchRowChunk, runQueries } from '../GscTools/query';

/**
 * The two requests one period needs: its property-level totals (A1/A2) and its daily series
 * (A3/A4). They travel together because neither is useful without the other — the totals supply
 * the headline metrics and the daily rows supply both the trend and the coverage gate that
 * decides whether those headline metrics may be compared at all.
 *
 * Current and baseline are fetched by separate calls to this function so that a baseline failure
 * leaves the current period's panels intact.
 *
 * `byProperty` aggregation is what makes these the property's own figures, which is why they are
 * never reconstructed by summing the page rows in the block below — that would quietly undercount
 * every page Search Console withheld.
 */
export async function fetchPeriod({
    credentialsDomainId,
    siteUrl,
    period,
    searchType,
    country,
    device,
    dataState,
}) {
    const common = {
        period,
        aggregationType: 'byProperty',
        dataState,
        searchType,
        country,
        device,
    };

    const results = await runQueries({
        credentialsDomainId,
        siteUrl,
        maxCount: MAX_ROW_LIMIT,
        queries: [
            { key: 'totals', resource: buildResource({ ...common, dimensions: [] }) },
            { key: 'daily', resource: buildResource({ ...common, dimensions: ['date'] }) },
        ],
    });

    return { totals: results.totals ?? [], daily: results.daily ?? [] };
}

/** One chunk of page rows for one period (A5/A6), paged by the shared row cursor. */
export function fetchPageChunk(options) {
    return fetchRowChunk({ ...options, dimension: 'page' });
}
